import { Usuario } from './usuario';
import { ReciboCliente } from './recibo-cliente';
import { ServicioCliente } from './servicio-cliente';
import { Business, ClientLookup, Person, User } from './user';

export class Client extends Usuario {
  reciboCliente?: ReciboCliente[];
  servicioCliente?: ServicioCliente[];
  constructor(obj?: any) {
    super(obj);
    if (obj.reciboCliente) {
      this.reciboCliente = obj.reciboCliente.map(
        (data: any) => new ReciboCliente(data),
      );
    }
    if (obj.servicioCliente) {
      this.servicioCliente = obj.servicioCliente.map(
        (data: any) => new ServicioCliente(data),
      );
    }
  }
}

export interface ClientInput {
  user: User;
  userDetails: Person | Business;
}

export interface ClientInputError {
  user?: {
    name?: string[];
    email?: string[];
  };
}

export interface ClientLookupResponse {
  exists: boolean;
  eligible?: boolean;
  client: ClientLookup | null;
}

export interface EmailCheckResponse {
  exists: boolean;
}

export interface ActivateClientInput {
  id: number;
}

//let obj = new CustomerReport();
